// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LYeBQ4BvAQKNQIP7CKlo{border:1px solid var(--border-neutral-default);background:var(--background-primary-inverted-primary,#fff);border-radius:6px;width:-webkit-fit-content;width:fit-content;padding:3px 7px;display:flex}.aOItcqIuDB0j5imjdfqu{cursor:pointer;margin-left:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `LYeBQ4BvAQKNQIP7CKlo`,
	"closeIcon": `aOItcqIuDB0j5imjdfqu`
};
export default ___CSS_LOADER_EXPORT___;
